import { render, staticRenderFns } from "./brand-info.vue?vue&type=template&id=2616b47b&"
import script from "./brand-info.vue?vue&type=script&lang=ts&"
export * from "./brand-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2616b47b')) {
      api.createRecord('2616b47b', component.options)
    } else {
      api.reload('2616b47b', component.options)
    }
    module.hot.accept("./brand-info.vue?vue&type=template&id=2616b47b&", function () {
      api.rerender('2616b47b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/brand-info.vue"
export default component.exports